import { useDispatch, useSelector } from "react-redux";
import TableAHSF from "../../../../Components/TableAHSF";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import PopupAHSF from "../../../../Components/PopupAHSF";
import AddEditProjectAdminTeam from "./AddEditProjectAdminTeam";
import { GetTE_MAinTeamMembersPreviousExperiencePartnershipsData } from "../../../../Redux/Reducers/ProjectInformationPage/ProjectManagementTeamMembers";

const ProjectAdminTeam = (props) => {
  const dispatch = useDispatch();
  const [jsonData, setJsonData] = useState({});
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);
  const [ProjectTeamId, setProjectTeamId] = useState(null);
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      TeamMembersPreviousExperiencePartnerships:
        state.TeamMembersPreviousExperiencePartnerships
          ?.TeamMembersPreviousExperiencePartnerships,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });
  //console.log(
  //   state.TeamMembersPreviousExperiencePartnerships
  //     ?.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
  //   "tE_MAinTeamMembersPreviousExperiencePartnershipsId"
  // );
  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  const RequestAccessor = [
    {
      KeyName: "fourPartName",
      ShowStatus: true,
      NmaeColumn: "الاسم من ثلاث مقاطع",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "gender",
      ShowStatus: true,
      NmaeColumn: "الجنس",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "natureOfWorkNameAr",
      ShowStatus: true,
      NmaeColumn: "طبيعة العمل",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "typeOfWorkNameAr",
      ShowStatus: true,
      NmaeColumn: "نوع العمل",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "idDocumentAttachment",
      ShowStatus: true,
      NmaeColumn: "مرفق وثيقة اثبات الشخصية",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      typeColumn: "file",
    },
    {
      KeyName: "cvDocumentAttachment",
      ShowStatus: true,
      NmaeColumn: "السيرة الذاتية",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      typeColumn: "file",
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        //console.log(e.target.value, "sssssssssssss");

        setProjectTeamId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: !shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
              "api/TE_PM_ProjectManagementTeamMembers/DeleteTE_PM_ProjectManagementTeamMembersData",
              {
                tE_ProjectManagementTeamMembersId: e.target.value,
              }
            );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            dispatch(setRefreshTable());
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        <AddEditProjectAdminTeam />
      </div>
    ),
    title: "اعضاء فريق العمل الاداري للمشروع",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEditProjectAdminTeam
          tE_ProjectManagementTeamMembersId={ProjectTeamId}
          canEdit="edit"
        />
      </div>
    ),
    title: "اعضاء فريق العمل الاداري للمشروع",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  //console.log(state.TeamMembersPreviousExperiencePartnerships, "ghhhghhg");

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"tE_PM_ProjectManagementTeamMembersId"}
        valueButtonAction={"tE_PM_ProjectManagementTeamMembersId"}
        URL={`api/TE_PM_ProjectManagementTeamMembers/GetTE_PM_ProjectManagementTeamMembersListData`}
        UrlBody={{
          tE_MAinTeamMembersPreviousExperiencePartnershipsId:
            props.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"أعضاء فريق العمل الإداري  للمشروع"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        fileStoreName={"IDDocumentAttachment"}
        fileStoreName2={"CVDocumentAttachment"}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  );
};

export default ProjectAdminTeam;
